module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/card-corner-purple-ba140128da4cda12675263b12e63c7fc.svg";